const API_BASE_URL = "https://cafemandhurah.mandurahcafe.com.au/api";

// Reusable function to get headers with token
const getHeaders = () => {
  // const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    // ...(token && { Authorization: `Bearer ${token}` }),
  };
};

// GET request
export const getRequest = async (endpoint) => {
  try {
    const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
      method: "GET",
      headers: getHeaders(),
    });

    const result = await response.json();

    if (response.ok) {
      return result;
    } else {
      throw new Error(result.message || "Something went wrong");
    }
  } catch (error) {
    console.error("Error occurred:", error);
    throw error;
  }
};

// POST request
export const postRequest = async (endpoint, data) => {
  try {
    const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (response.ok) {
      return result;
    } else {
      throw new Error(result.message || "Something went wrong");
    }
  } catch (error) {
    console.error("Error occurred:", error);
    throw error;
  }
};

// PUT request
export const putRequest = async (endpoint, data) => {
  try {
    const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (response.ok) {
      return result;
    } else {
      throw new Error(result.message || "Something went wrong");
    }
  } catch (error) {
    console.error("Error occurred:", error);
    throw error;
  }
};

// DELETE request
export const deleteRequest = async (endpoint) => {
  try {
    const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
      method: "DELETE",
      headers: getHeaders(),
    });

    const result = await response.json();

    if (response.ok) {
      return result;
    } else {
      throw new Error(result.message || "Something went wrong");
    }
  } catch (error) {
    console.error("Error occurred:", error);
    throw error;
  }
};
